import { initNavigationData } from '@/utils/store/devices/devicesListNavigation';
import { DevicesState } from './types';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export { namespace } from './types';

export const state: DevicesState = {
  devicesListComponentsState: {
    loading: {
      devicesList: false,
      numberOfActiveDevices: false,
      devicesActivity: false,
      devicesHistory: {},
      tollingUpdateState: false,
      devicesTollDomains: false,
      devicesTollDomainsNames: false,
      devicesVehiclesInformations: false
    },
    error: {
      devicesList: false,
      numberOfActiveDevices: false,
      devicesActivity: false,
      devicesHistory: {},
      tollingUpdateState: false,
      devicestollDomains: false,
      devicesTollDomainsNames: false,
      devicesVehiclesInformations: false
    },
    fetched: {
      devicesList: false,
      numberOfActiveDevices: false,
      devicesActivity: false,
      devicesHistory: {},
      tollingUpdateState: false,
      devicesTollDomains: false,
      devicesTollDomainsNames: false,
      devicesVehiclesInformations: false
    }
  },
  devices: {
    devicesList: [],
    devicesHistory: [],
    numberOfActiveDevices: 0,
    devicesTollDomainsList: [],
    devicesTollDomainsNames: [],
    navigation: initNavigationData,
    total: -1
  },
  userSelection: {
    devices: [],
    actions: {
      tollingUpdate: {
        label: 'device.actions.update_status',
        enabled: false
      },
      reboot: {
        label: 'device.actions.reboot_device',
        enabled: false
      }
      // TO BE USED LATER
      // subscriptionUpdate: {
      //   label: 'device.subscription.title',
      //   enabled: false
      // }
    }
  },
  suggestions: undefined,
  savedFilters: {
    selectedFilters: [],
    multiSearch: ''
  }
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
